export default __webpack_public_path__ + "static/media/play-store-white.f34d67bb.svg";